module.exports = __webpack_public_path__ + "img/vk-black.57de50b.svg?v=1791296779994";